
<template>
    <div class="solution-summary pb-2">
        
        <div v-if="is_loading.pmpCases" v-loading="true" class="p-5"></div>
        
        <div v-else>
            <div v-if="property_draft_products.length > 0">
                <div v-for="(product, index) in property_draft_products" :key="product.prod_id">
                    <AdditionalRebateModal ref="additionalRebateModal" :product="product" :pmp_case_details="pmpCaseDetails[product.prod_id]"/>
                    <b-card no-body>
                        <a href="javascript:void(0)" 
                            @click="removeProductHandler(product)"
                            class="position-absolute"
                            style="left: -4px; top: -7px;"
                        >
                            <b-icon icon="x-circle-fill" class="text-danger"></b-icon>
                        </a>
                        <b-card-header header-bg-variant="primary" header-class="p-2 text-white">
                            <div class="d-flex justify-content-between align-items-center">
                                <span class="font-weight-500">Property Loan</span>
                                <el-button type="text" style="color: white !important" class="py-0"  
                                    @click="addBank(product.prod_id, product.product_detail.prod_pm_property_id)"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 448 512"><path fill="currentColor" d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32v144H48c-17.7 0-32 14.3-32 32s14.3 32 32 32h144v144c0 17.7 14.3 32 32 32s32-14.3 32-32V288h144c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"/></svg>
                                    Add Bank
                                </el-button>
                            </div>
                        </b-card-header>
                        <b-card-body class="px-4 pt-2 pb-4">
                            <div>
                                <b-row v-if="product.product_banks.length === 0" class="mb-1">
                                    <b-col>
                                        <p>No Bank Found.</p>
                                    </b-col>
                                </b-row>
                                <div
                                    v-for="(bank,index) in product.product_banks" 
                                    :key="index"
                                    class="border rounded bg-secondary position-relative p-3 mt-3"
                                >
                                    <a href="javascript:void(0)" 
                                        @click="removePropertyProductBankHandler(bank)"
                                        class="position-absolute"
                                        style="left: -7px; top: -8px;"
                                    >
                                        <b-icon icon="x-circle-fill" class="text-danger"></b-icon>
                                    </a>
                                    <b-row>
                                        <b-col cols="12" md="4" class="border-right">
                                            <p class="font-weight-500">{{ bank.prod_bnk_name }}</p>
                                            <div class="d-flex align-items-center mb-3">
                                                <el-image
                                                    class="rounded mr-2"
                                                    :src="bank.prod_bnk_logo_url"
                                                    fit="cover"
                                                    style="height: 25px;"
                                                ></el-image>
                                            </div>
                                            <b-row>
                                                <b-col cols="6">
                                                    <p class="text-muted">Interest rate</p>
                                                    <p>{{bank.prod_bnk_interest}}% p.a</p>
                                                </b-col>
                                                <b-col cols="6">
                                                    <p class="text-muted">Tenure</p>
                                                    <p>{{ bank.prod_bnk_tenure }} years</p>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                        <b-col cols="12" md="auto" align-self="center">
                                            <span class="text-xs">Loan Amount</span>
                                            <h4 class="font-weight-600">RM {{ bank.prod_bnk_loan_amount | moneyFormatter }}</h4>
                                        </b-col>
                                        <b-col cols="12" md="6">
                                            <b-row>
                                                <b-col cols="12" md="6">
                                                    <b-form-group label="SPA Price">
                                                        <b-form-input
                                                        v-model="bank.prod_bnk_spa_amount"
                                                        type="text"
                                                        required
                                                        @change="updatePropertyProductBank(bank)"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" md="6">
                                                    <b-form-group label="Instalment">
                                                        <b-form-input
                                                        v-model="bank.prod_bnk_installment"
                                                        type="text"
                                                        required
                                                        @change="updatePropertyProductBank(bank)"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="12" md="6">
                                                    <b-form-group label="Margin of Finance">
                                                        <b-form-input
                                                        v-model="bank.prod_bnk_margin"
                                                        type="text"
                                                        required
                                                        @change="updatePropertyProductBank(bank)"
                                                        ></b-form-input>
                                                    </b-form-group>
                                                </b-col>
                                            </b-row>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </b-card-body>
                    </b-card>
                    <div class="border rounded mt-2 mb-5" style="background: #fffff2; border-color: #FBC737 !important">
                        <b-row>
                            <b-col cols="12" md="8" class="border-right" style="border-color: #FBC737 !important">
                                <div class="p-3">
                                    <p class="font-weight-500">Booking Form</p>
                                    <b-form-group label="1. Once you fill up the form, upload the form here">
                                        <vue-dropzone id="bookingFormDropzone" 
                                            class="py-0"
                                            ref="bookingFormDropzone"
                                            :options="dropzoneOptions" 
                                            :useCustomSlot=true
                                            v-on:vdropzone-error="dropzoneErrorBookingForm"
                                            v-on:vdropzone-file-added="dropzoneAddedBookingForm"
                                            v-on:vdropzone-removed-file="dropzoneRemovedBookingForm"
                                        >
                                            <b-icon icon="cloud-arrow-up-fill" font-scale="3"></b-icon>
                                            <p class="mb-0">Upload booking form or Drop files here</p>
                                        </vue-dropzone>
                                    </b-form-group>
                                    <b-form-group label="2. Select Payment">
                                        <el-radio-group v-model="form.payment">
                                            <el-radio-button label="Payment Link">Payment Link</el-radio-button>
                                            <el-radio-button label="Pay Later">Pay Later</el-radio-button>
                                            <el-radio-button label="Pay On Behalf">Pay On Behalf</el-radio-button>
                                            <el-radio-button label="Upload Payment Slip">Upload Payment Slip</el-radio-button>
                                        </el-radio-group>
                                    </b-form-group>
                                </div>
                            </b-col>
                            <b-col cols="12" md="4">
                                <div class="p-3">
                                    <div class="d-flex align-items-center mb-4">
                                        <el-image
                                            style="width: 100px; height: 100px"
                                            class="rounded mr-2"
                                            :src="product.prod_image_url"
                                            fit="cover"
                                        ></el-image>
                                        <div>
                                            <p class="font-weight-500">{{ product.product_detail.prod_pm_project_name }}</p>
                                            <p class="font-weight-600">RM {{ product.product_detail.prod_pm_spa_price | moneyFormatter }}</p>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center">
                                        <p>{{ product.product_detail.prod_pm_unit_no }}</p> 
                                        <svg xmlns="http://www.w3.org/2000/svg" class="mx-2 d-none d-md-block " width="6" height="6" viewBox="0 0 512 512"><path fill="#73839C" d="M256 464c-114.69 0-208-93.31-208-208S141.31 48 256 48s208 93.31 208 208-93.31 208-208 208Z"/></svg>
                                        <p>{{ product.product_detail.prod_pm_property_size }} sqft.</p>
                                    </div>
                                    <p>{{ product.product_detail.prod_pm_property_type }}</p>
                                    <el-button type="text" :loading="is_loading.overview" @click="projectOverview(product.product_detail)">
                                        Project Overview
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ml-1" width="10" height="12" viewBox="0 0 320 512"><path fill="currentColor" d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>
                                    </el-button>
                                    <p class="font-italic text-xs">You can obtain Booking Form under Property Details by clicking the link above</p>
                                </div>
                            </b-col>
                            <b-col cols="12">
                                <div class="p-3">
                                    <el-button class="bg-success py-2 text-white mt-5" 
                                        @click="convertProductToCaseHandler(product)" 
                                        :loading="is_loading.case && is_loading.value === product.prod_id"
                                    >
                                            <small class="font-weight-bold text-white">CONVERT TO CASE</small>
                                    </el-button>
                                    
                                    <el-button class="bg-dark outline-none text-white p-2" 
                                        @click="$refs.additionalRebateModal[index].toggleView()"
                                        v-if="pmpCaseDetails && pmpCaseDetails[product.prod_id] && 
                                        pmpCaseDetails[product.prod_id].settings.cb_add_percent_to_customer && pmpCaseDetails[product.prod_id].settings.cb_add_percent_to_customer > 0"
                                    >
                                        <span v-if="pmpCaseDetails[product.prod_id].additional_info.additional_rebate_approval.approval_check === null">
                                            <b-icon icon="clock" class="text-warning mr-1"></b-icon>
                                        </span>
                                        <span v-if="pmpCaseDetails[product.prod_id].additional_info.additional_rebate_approval.approval_check == 1">
                                            <b-icon icon="check" scale="1.5" class="text-success mr-1"></b-icon>
                                        </span>
                                        <span v-if="pmpCaseDetails[product.prod_id].additional_info.additional_rebate_approval.approval_check == 0">
                                            <b-icon icon="x" scale="1.5" class="text-danger mr-1"></b-icon>
                                        </span>
                                        Request Additional {{ pmpCaseDetails[product.prod_id].settings.cb_add_percent_to_customer }}% Rebate
                                    </el-button>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </div>
            <div class="text-center mt-5" v-else>No draft found.</div>
        </div>
    </div>
</template>
<script>
import { Image, Button, RadioGroup, RadioButton } from 'element-ui'
import vue2Dropzone, { methods } from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { mapState, mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { usePMPStore } from '@/stores/pmpStore'
import { useNotificationStore } from '@/stores/notificationStore'
import { useMessagingStore } from '@/stores/messagingStore'
import { useCustomerStore } from '@/stores/customerStore'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import {
    helperFunctionMixin,
    notifyFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import { useHestiaStore } from '@/stores/hestiaStore'
import AdditionalRebateModal from '@/views/CustomerProfile/CustomerProfileDetails/OffCanvasDetails/DrawerCaseDetails/Modals/AdditionalRebateModal.vue';

export default {
    components: {
        AdditionalRebateModal,
        vueDropzone: vue2Dropzone,
        [Image.name]: Image,
        [Button.name]: Button,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
    },
    mixins: [notifyFunctionMixin, helperFunctionMixin],
    data() {
        return {
            is_loading: {
                case: false,
                value: null,
                overview: false,
                pmpCases: true
            },
            selected_solution: true,
            selected_products: [],
            dropzoneOptions: {	
                url: '#',
                addRemoveLinks: true,
                maxFiles: 1,
                autoProcessQueue: false,
                acceptedFiles: "application/pdf,image/jpeg,image/png",
            },
            form: {
                booking_form: null,
                payment: '',
            },
            pmpCaseDetails: {},

        }
    },
    computed:{
        ...mapState(useProductStore, ['property_draft_products']),
        ...mapState(useCustomerStore, ['current_customer']),
        has_product(){
            return this.property_draft_products.length > 0
        },
    },
    watch: {
    async property_draft_products() {
        this.is_loading.pmpCases = true;
        await this.getCaseDetails(); 
        this.is_loading.pmpCases = false;
      }
  },

    methods:{
        ...mapActions(useProductStore, ['removeProduct', 'updatePropertyProductBank', 'removePropertyProductBank', 'convertProductToCase', 'setSelectedProperty']),
        ...mapActions(usePMPStore, ['getProjectById']),
        ...mapActions(useNotificationStore, ['fetchEmailTemplate']),
        ...mapActions(useMessagingStore, ['sendEmail']),
        ...mapActions(useHestiaStore, ['getHestiaCaseDetails']),
        resetIsLoading(){
            this.is_loading.case = false
            this.is_loading.value = null
        },
        dropzoneErrorBookingForm(file, error, xhr){
            this.form.booking_form = null
        },
        dropzoneAddedBookingForm(file){
            this.form.booking_form = file
        },
        dropzoneRemovedBookingForm(file, error, xhr){
            this.form.booking_form = null
        },
        copyToClipboard(value) {
            const tempInput = document.createElement('input');
            tempInput.value = value;
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand('copy');
            document.body.removeChild(tempInput);

            this.notifySuccess('Copied to Clipboard.')
        },
        selectCase(id){
            if(this.selected_products.includes(id)){
                const index = this.selected_products.indexOf(id);
                this.selected_products.splice(index, 1);
            }else{
                this.selected_products.push(id)
            }
        },
        addBank(product_id, project_id){
            this.$router.replace({query: Object.assign({ ...this.$route.query }, 
                {
                    product_id:product_id,
                    project_id:project_id
                }
            ),},() => {})
            solutionEventBus.$emit('show-bank-selections')
        },
        emitEvent(...eventNames) {
            eventNames.forEach(eventName => {
                solutionEventBus.$emit(eventName)
            })
        },
        async projectOverview(project) {
            this.is_loading.overview = true

            try{
                const resp = await this.getProjectById(project.prod_pm_property_id, project.prod_pm_property_src)
                if (resp.status === 200) {
                    this.setSelectedProperty(resp.data.data)
                    this.emitEvent('show-property-selections')
                }
            }catch(e){
                console.log('PMP Store (getProjects) failed:' + e.response.data.message)
                throw e
            }
            this.is_loading.overview = false
            
        },
        async removePropertyProductBankHandler(bank){
            try{
                await this.removePropertyProductBank(bank)
                this.notifySuccess('<b>Bank </b> - Successfully Removed.')
            }catch(e){
                this.errorFunction(null, e)
            }
        },
        async removeProductHandler(product){
            try{
                await this.removeProduct(product)
                this.notifySuccess('<b>Draft </b> - Successfully Removed.')
            }catch(e){
                this.errorFunction(null, e)
            }
        },

        async getCaseDetails(){
            for (const product of this.property_draft_products) {
                if (!this.pmpCaseDetails[product.prod_id]){
                    console.log('entered');
                    try{
                        if(product.product_detail.prod_pm_property_src == 'HESTIA') {
                                this.pmpCaseDetails[product.prod_id] = await this.getHestiaCaseDetails(product.product_detail.prod_pm_unit_id)
                        }
                        else
                        {      
                        const res = await axios.get(services.lookup + 'pmp/cases.im2uv2/'+ product.prod_id, {headers: getHeader()})
                        this.pmpCaseDetails[product.prod_id] = res.data
                        }
                    }
                    catch(e){
                        this.errorFunction(e)
                    }
                }
            }
        },
        async convertProductToCaseHandler(product){
            this.is_loading.case = true
            this.is_loading.value = product.prod_id

            if (this.form.payment) {
                product.prod_payment_method = this.form.payment
            }

            if (this.form.booking_form) {
                product.prod_booking_content = await _gHlp.convertFileToBase64(this.form.booking_form) 
            }

            try{

                await this.convertProductToCase(product.prod_id, 'property')
                await this.sendCaseApprovalEmail(product.prod_id)
                      
                this.resetIsLoading()
                if(this.checkAppCode('sas')){
                    this.notifySuccess('<b>Case Successfully Created </b> - Pending Approval.')
                }else{
                    this.notifySuccess('<b>Case Successfully Created </b>')
                }
            }catch(e){
                this.errorFunction(e)
                this.resetIsLoading()
                return
            }
        },
        async sendCaseApprovalEmail(id) {
          try{
            const emailTemplate = await this.fetchEmailTemplate('CREATE_CASE_APPROVAL');
            if (emailTemplate && emailTemplate.is_active == 1) {

            const recipients = emailTemplate.notif_temp_receiver.split(',').map(email => email.trim());

            // Prepare the email data
            const emailData = {
                to: recipients,
                subject: emailTemplate.notif_temp_title,
                body: emailTemplate.notif_temp_message
                    .replace('{case_id}', id) // Replace {case_id} with product ID
            };

            await this.sendEmail(emailData);
              this.notifySuccess('Email sent successfully.');
            }
          } 
          catch (error) {
              console.error('Failed to send email:', error);
              this.errorFunction(error);
          }
        },
        createCaseRecognizeAndCommsPayoutSummary(product) {
            const lead_type = this.current_customer.type == '' ? null : this.current_customer.type;
            const case_recognize = {
                "user_id": this.current_customer.se ? this.current_customer.se.id ?? null : null,
                "case_id": product.prod_id,
                "hub_id": this.current_customer.lead ? this.current_customer.lead.hub_id ?? null : null,
                "use_user_id": this.current_customer.sse ? this.current_customer.sse.id ?? null : null,
                "use_user_id2": this.current_customer.ssa ? this.current_customer.ssa.id ?? null : null,
            }
            const customer_basket = this.current_customer.basket.basket_color;

            let postData = {}
            let service_type_code;
            
            switch(lead_type)
            {
                case null:
                    service_type_code = customer_basket != 'Green' ? 'COMPANY_PROPERTY_WITH_ADVISORY_SERVICE' : 'COMPANY_PROPERTY_NO_ADVISORY_SERVICE';
                break;
                case 'Company':
                    service_type_code = customer_basket != 'Green' ? 'COMPANY_PROPERTY_WITH_ADVISORY_SERVICE' : 'COMPANY_PROPERTY_NO_ADVISORY_SERVICE';
                break;
                case 'Personal':
                    service_type_code = customer_basket != 'Green' ? 'PERSONAL_PROPERTY_WITH_ADVISORY_SERVICE' : 'PERSONAL_PROPERTY_NO_ADVISORY_SERVICE';
                break;
            }

            postData = {
                ...case_recognize,
                "product_id": 1,
                "lead_type_code": lead_type == null ? 'company' : lead_type,
                "service_type_code": service_type_code,
                "cps_develop_nett_price":product.product_detail. prod_pm_net_buyer_discount
            }
            
            axios.post(services.hub + 'hub_comms/comms_payout_summary.create_case_recognize_and_comms_payout_summary', postData, {headers: getHeader()})
            .then(res => {
                this.notifySuccess('<b>Case Recognize and Comms Payout Summary</b> - Successfully created.')                
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
    }
}
</script>